<template>
  <div class="page-wrap">
    <div class="container">
      <h1 class="page-title">海藻科学</h1>
      <div class="feature_divider"></div>
      <div class="moto-area">
        <div>汇集了海藻显着的健康和美容功效以及地球上最好的天然成分。简直就是世界上最有效的护肤、身体护理和化妆品配方。 </div>
      </div>
      <div class="feature_divider"></div>
      <div class="image-text-area" v-for="(item, index) in seaweed" :key="index">
        <articleSeaweed :article="item" :position="index%2===0?'left':'right'" :goodsIncludes="goodsCludes[item.id]" />
      </div>
    </div>
  </div>
</template>

<script>
import articleSeaweed from '@/components/article/Seaweed.vue'
export default {
  components: {
    articleSeaweed
  },
  data () {
    return {
      seaweed: [
        { id: 18, title: 'Repêchage® 和海藻', image: require('@/assets/images/seaweed/15.jpg'), des: '它在以色列的沙漠中被用作植物营养素。如果它能为沙漠补水，想象一下它能为您的皮肤做些什么！想让你的皮肤看起来容光焕发？您可以相信使用海藻可以增加水合作用并改善肤色。科学家认为，海藻产生了地球上 70% 以上的氧气。海藻通过渗透作用从海水中吸收矿物质和维生素来养活自己。通过独家专有方法，Repêchage 化学家从海藻纤维组织中去除细胞间液，同时保留维生素、矿物质、微量元素和氨基酸的活性。研究人员指出海水与人体血浆（我们的细胞间液）之间几乎不可思议的相似性。海洋覆盖了我们星球的三分之二以上，而且，也许并非巧合，人体也有三分之二是由水构成的。' },
        { id: 19, title: 'Repêchage®和水产养殖', image: require('@/assets/images/seaweed/20.jpg'), des: '在美国缅因州海岸附近，Repêchage 与领先的科学家和水产养殖者合作，以可持续的方式收获多种营养丰富的海藻。从最原始的环境（例如缅因州东海岸外）采购海藻是关键。海藻可以野生收获，也可以通过水产养殖种植。对于野外收获，收获发生在清晨，在伴随着新月和满月的春季和夏季月份的最低潮汐期间。或者，可以在悬挂在海​​水中的绳索上种植海藻，沿着漂浮的绳索用船收割，然后收集到收割船上的网或大型储物箱中。作物在一两个月的时间内收获，直到温度条件限制作物的生长。海藻最初储存在湿室中，然后在尽量减少生物活性化合物降解的温度下干燥' },
        { id: 1, title: '海藻对皮肤的许多好处', image: require('@/assets/images/seaweed/1.jpg'), des: 'Repêchage 是美国海洋植物技术的先驱，也是海藻护理和化妆品的先驱，已开发出全系列以海藻为基础的护肤产品，在全球顶级水疗中心大放异彩。我们的 EcoCert 海藻是从法国布列塔尼海岸和缅因州海岸附近的纯净海水中可持续种植和收获的，然后通过我们专有的方法在美国进行加工。' },
        { id: 2, title: '当科学遇上护肤', image: require('@/assets/images/seaweed/2.jpg'), des: '在 Repêchage，我们一直在对海藻的新应用进行持续研究，并研究最新成分以帮助解决与皮肤相关的问题。正是出于这个原因，我们邀请康涅狄格州斯坦福康涅狄格大学生态学和进化生物学教授 Charles Yarish 博士加入我们，成为 Repêchage 董事会成员。下面，Yarish 博士对海藻在皮肤护理中的许多重要应用提供了有趣的见解。' },
        { id: 3, title: '掌状海带', image: require('@/assets/images/seaweed/3.jpg'), des: '在大西洋和太平洋极低潮间带和浅潮下带海洋环境中发现了一种棕色海藻。这种海藻通常被称为马尾海带，是 12 种维生素的天然来源，包括维生素 B12、C、E、K 和β胡萝卜素，以及多达 42 种微量元素。掌状海带以其特殊的保湿能力而备受青睐。此类海藻提取物还含有谷胱甘肽（GSH）前体半胱氨酸、甘氨酸和谷氨酸，以及其他 15 种氨基酸。已证明谷胱甘肽能有效防止体内色素沉着。' },
        { id: 4, title: '刺松藻', image: require('@/assets/images/seaweed/4.jpg'), des: '一种绿色海藻，附着在大小从 1 厘米到几米不等的岩石上，主要存在于潮间带到浅潮下带海洋环境中，具有分枝状圆柱形复叶。已证明有助于及时补充水分。' },
        { id: 5, title: '泡叶藻', image: require('@/assets/images/seaweed/5.jpg'), des: '一种棕色海藻，在北大西洋的上层潮间带和潮下浅层海洋环境中繁衍生息。它含有丰富的维生素、矿物质和氨基酸、褐藻糖胶和海藻酸。' },
        { id: 6, title: '扁浒苔（原名对扁浒苔）', image: require('@/assets/images/seaweed/6.jpg'), des: '绿色薄板或管状结构，在全世界许多近岸环境中都有发现。有助于皮肤紧致肌肤。' },
        { id: 7, title: '伊穀草（别称“美丽伊谷草”）', image: require('@/assets/images/seaweed/7.jpg'), des: '一种坚硬的潮下带红色海藻，主要产于夏威夷群岛海岸，北大西洋海岸也有发现，常与海带附着器生长在一起。有助于保持肌肤水分和舒缓皮肤' },
        { id: 8, title: '石莼', image: require('@/assets/images/seaweed/8.jpg'), des: '一种绿色海藻，主要生长于世界各地的潮间带和浅潮下带海洋环境。有助于延缓衰老，减少细纹。' },
        { id: 9, title: '长心卡帕藻', image: require('@/assets/images/seaweed/9.jpg'), des: '也被称为麋鹿角海苔，是角叉菜胶的主要来源。从长心卡帕藻中提取的生物聚合物可在皮肤表面形成一层临时性不可见柔性薄膜。' },
        { id: 10, title: '墨角藻', image: require('@/assets/images/seaweed/10.jpg'), des: '这种棕色大型海藻通常被称为岩藻。主要存在于北大西洋的潮间带至浅潮下带海洋环境中。富含维生素，含有岩藻聚糖和藻酸。此类海藻有助于深层清洁肌肤，减少油脂' },
        { id: 11, title: '紫球藻', image: require('@/assets/images/seaweed/11.jpg'), des: '一组单细胞红色微藻，富含人体必需的脂肪酸以及维生素 B 和 C，有助于改善油性皮肤。' },
        { id: 12, title: '具距石枝藻', image: require('@/assets/images/seaweed/12.jpg'), des: '一种红藻，其主要特征是在细胞壁中形成碳酸钙。能有效紧致肌肤，使肌肤更加富有弹性。' },
        { id: 13, title: '沟鹿角菜', image: require('@/assets/images/seaweed/13.jpg'), des: '一种褐藻，主要附着于大西洋东部潮间带上部岩石海岸的岩石上生长。有助于减少黑斑。' },
        { id: 14, title: '螺旋藻', image: require('@/assets/images/seaweed/14.jpg'), des: '蓝藻也称为蓝绿藻，在水生环境中自由漂浮并形成藻席。蛋白质含量非常高，是天然胡萝卜素、维生素 E 和锌等必需氨基酸的主要来源。含有β-胡萝卜素和藻胆蛋白。' },
        { id: 15, title: '褐藻', image: require('@/assets/images/seaweed/17.png'), des: '是一种棕色海藻，生长在北大西洋的上潮间带和浅潮下带海洋环境中。通常被称为泡叶藻或岩藻。富含维生素、矿物质、氨基酸、植物激素、岩藻聚糖和藻酸。有助于使肌肤光滑柔软。' },
        { id: 16, title: '皱波角叉菜', image: require('@/assets/images/seaweed/18.png'), des: '也被称为爱尔兰苔藓和角叉菜胶。呈灌木状，浓密分枝，顶端短分叉。红色渐变到紫色、棕色、黑色，但在阳光照射下，呈米白色或象牙色。主要生长于潮下带岩石的水下部分。有助于软化和滋润皮肤。' },
        { id: 17, title: '珊瑚藻提取物', image: require('@/assets/images/seaweed/19.png'), des: '一种钙化红色海藻，有助于舒缓皮肤，减少发红。' }
      ],
      goodsCludes: {
        3: ['臻蓝水漾®系列', '舒缓焕活®系列', '赋活修复 ™系列', '舒缓祛红®系列'],
        15: ['臻蓝水漾®系列', '赋活修复 ™系列'],
        6: ['舒缓焕活®系列'],
        4: ['臻蓝精华棒', '赋活修复 ™系列'],
        7: ['舒缓焕活®系列'],
        8: ['臻蓝水漾®系列', '瑞波琴舒缓焕活日霜'],
        10: ['瑞波琴净透控油海泥修护面膜'],
        11: ['净透控油®系列'],
        12: ['瑞波琴净透控油海泥修护面膜'],
        16: ['舒缓焕活®系列', '臻蓝水漾®系列', '臻蓝精华棒®'],
        9: ['瑞波琴凝颜焕采紧致面膜', '瑞波琴赋活修复保湿霜', '瑞波琴赋活修复眼霜'],
        17: ['臻蓝精华棒']
      }
    }
  }
}
</script>

<style scoped>
.container{
  font-family: Montserrat, sans-serif;
  max-width: 1200px;
  margin: 0 auto;
  padding: 65px 10px 50px;
}
.feature_divider{
  width: 100%;
  border-bottom: 1px solid;
  border-color: #cccccc;
  margin-bottom: 30px;
}
.page-title{
  font-size: 34px;
  margin-bottom: 35px;
  color: #25282a;
  font-weight: 400;
  font-style: normal;
  padding-top: 4px;
}
.picture{
  width: 100%;
}
.moto-area{
  color: #000;
  font-size: 21px;
  font-weight: 400;
  line-height: 33px;
  font-style: italic;
  margin: 1% 10% 5%;
}
.moto-sign{
  text-align: right;
  padding-top: 15px;
}
.video-area{
  margin: 50px 0 30px;
}
.video{
  width: 100%;
}
.image-text-area{
  padding: 50px 0;
  border-bottom: 1px solid #DCDFE6;
}
</style>
